/**
 * Image Slideshow Component
 * Handles the initialization and configuration of image slideshows using Slick carousel
 */

class ImageSlideshow {
  constructor(element) {
    this.slider = element;
    this.autoplay = this.slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.slider.dataset.autoplaySpeed) || 5000;
    this.init();
  }

  init() {
    if (typeof jQuery === 'undefined') {
      console.error('jQuery is required for Image Slideshow');
      return;
    }

    if (typeof jQuery.fn.slick === 'undefined') {
      console.error('Slick carousel is required for Image Slideshow');
      return;
    }

    this.initSlick();
  }

  initSlick() {
    const $slider = jQuery(this.slider);

    $slider.slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      adaptiveHeight: false,
      lazyLoad: 'ondemand',
    });

    // Ensure images are loaded properly
    $slider.on('init reInit', function() {
      const $slides = jQuery(this).find('.slick-slide');
      $slides.each(function() {
        const $img = jQuery(this).find('img');
        if ($img.length) {
          $img.on('load', function() {
            jQuery(this).css('opacity', '1');
          });
        }
      });
    });
  }

  destroy() {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(this.slider).slick('unslide');
    }
  }
}

// Initialize all slideshows on the page
document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('.image-slideshow__slider');

  slideshows.forEach(function(slideshow) {
    new ImageSlideshow(slideshow);
  });
});

// Reinitialize on Shopify theme editor changes
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const slideshow = event.target.querySelector('.image-slideshow__slider');
    if (slideshow) {
      new ImageSlideshow(slideshow);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const slideshow = event.target.querySelector('.image-slideshow__slider');
    if (slideshow && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(slideshow).slick('unslick');
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const slideshow = event.target.closest('.image-slideshow__slider');
    if (slideshow) {
      const blockIndex = Array.from(event.target.parentElement.children).indexOf(event.target);
      jQuery(slideshow).slick('slickGoTo', blockIndex);
    }
  });
}
